<template>
  <div style="width: 100%;height: 100vh">
    <!--<Form ref="editForm" :label-width="100" :model="formData" inline>
      <FormItem label="站点类型" prop="station_type">
        <Select v-model="formData.station_type" placeholder="站点类型">
          <Option value="">全部站点</Option>
          <Option v-for="item in station_types" :value="item.id">{{item.name}}</Option>
        </Select>
      </FormItem>
      <Button type="primary" @click="getStations">确定</Button>
    </Form>-->

    <div id="mapContainer" style="width:100%;height: 100%"></div>
  </div>
</template>

<script>
  import AMapLoader from '@amap/amap-jsapi-loader';
  export default {
    name: "mapStation",
    data() {
      return {
        formData:{
          gas_name:'',
          station_type:'',
          platform:''
        },
        station_types:[],
        platform:[]
      }

    },
    methods: {
      async initMap(){
        AMapLoader.load({
          key:"c3219f1ed0f4493a4f3ca6ead5e51d37",     // 申请好的Web端开发者Key，首次调用 load 时必填
          version:"2.0",      // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
          plugins:['AMap.LabelsLayer','AMap.LabelMarker'],       // 需要使用的的插件列表，如比例尺'AMap.Scale'等
        }).then((AMap)=>{
          this.map = new AMap.Map("mapContainer",{  //设置地图容器id
            // viewMode:"3D",    //是否为3D地图模式
            zoom:5,           //初始化地图级别
            center:[108.55,34.32], //初始化地图中心点位置
          });
          this.AMap = AMap;
          this.labelsLayer = new this.AMap.LabelsLayer({
            zooms: [3, 20],
            zIndex: 1000,
            // 该层内标注是否避让
            collision: true,
            // 设置 allowCollision：true，可以让标注避让用户的标注
            allowCollision: true,
          });
          this.getStations()
        }).catch(e=>{
          console.log(e);
        })
      },
      async getStations(){
        //先清空所有的
        this.labelsLayer.clear();
        let stations = await this.$commonFun.postProxy('admin/station_collect/getAllStations',this.formData)
        if(!stations.data)  return  false;

        stations.data.forEach((item)=>{
          let icon = {
            type: 'image',
            image: item.icon,
            size: [30, 30],
            anchor: 'center',
          }, text = {
            content: item.station_type_name,
            direction: 'right',
            offset: [-5, -5],
            style: {
              fontSize: 12,
              fillColor: '#1e2696',
              strokeColor: '#fff',
              strokeWidth: 2,
            }
          };
          let labelMarker = new this.AMap.LabelMarker({
            name: item.gas_name, // 此属性非绘制文字内容，仅最为标识使用
            position: [item.longitude, item.latitude],
            zIndex: 16,
            icon: icon,
            text: text,
          });
          labelMarker.on("click",()=>{
            this.openInfoWindow(item)
          })
          this.labelsLayer.add(labelMarker)
        })

        this.map.add(this.labelsLayer);
      },
      openInfoWindow(item){
        let content = [
          '<div>',
          `<b>${item.province_name}${item.city_name}${item.area_name}</b><br/>`,
          `<span>${item.address}</span><br/>`,
          '</div>'
      ];
      // 创建 infoWindow 实例
        let infoWindow = new this.AMap.InfoWindow({
          anchor: 'top',
          offset:[15,-10],
          content: content.join("")  //传入 dom 对象，或者 html 字符串
        });
        // 打开信息窗体
        infoWindow.open(this.map,[item.longitude, item.latitude]);
      },
      async initPage(){
        let data = await this.$commonFun.postProxy('admin/common/getPageInitInfo',{type:['stationType','platform']})
        this.station_types = data.data.stationType
        this.formData.station_type = 'oil_station'
      }
    },
    mounted() {
      this.initPage();
      this.initMap();
    },
  }
</script>

<style scoped>

</style>
